/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment/moment';
import * as actionTypes from './actionTypes';

const initilaState = {
  tabDetails:{},
  invoiceDetailsByPQR: [],
  invoiceDetailsByInvoiceNum: {},
  handlingCodeValues: [],
  invoiceQuarter: [],
  invoiceStatusCodeValues: [],
  balanceStatusCodeValues: [],
  saveRequestData: {},
  searchInvoiceRequest: {
    quarter: '',
    rebateProgramCode: '',
    shortDescr: '',
    planType: '',
    page: '0',
    pageSize: '100',
    saveButtonEnable: false,
  },
  selectedClient: '',
  invoiceNumber: '',
  drugActivity: {},
  checkLogDetails: {},
  invoiceOther_hideZeroBalance: true,
  invoiceOther_selectedQtr: '',
  isCheckLogOpen: false,
  noRecordFound: false,
  invoiceSearchCount: 0,
  searchClicked: false,
  errorMessages: [],
  displayInvoiceObj: {
    tabValue: 0,
  },
  mfgSelected: {},
};

const isInvoiceNumNotFound = (payload) => {
  if (payload == null || payload === '') return true;
  if (typeof payload === 'string') {
    const lower = payload.toLowerCase();
    return lower.includes('no record') || lower.includes('not found');
  }
  const data = payload?.data ?? payload?.message;
  if (typeof data === 'string') {
    const lower = data.toLowerCase();
    return lower.includes('no record') || lower.includes('not found');
  }
  return false;
};

const reducer = (state = initilaState, action) => {
  switch (action.type) {
    case actionTypes.GET_INVOICE_DETAILS_BY_PQR: {
      return { ...state, invoiceDetailsByPQR: action.payload };
    }
    case actionTypes.GET_INVOICE_DETAILS_BY_INVOICE_NUM: {
      const notFound = isInvoiceNumNotFound(action.payload);
      return {
        ...state,
        invoiceDetailsByInvoiceNum: notFound
          ? state.invoiceDetailsByInvoiceNum
          : action.payload || {},
        noRecordFound: notFound,
        invoiceSearchCount: (state.invoiceSearchCount || 0) + 1,
        searchClicked: !state.searchClicked,
      };
    }
    case actionTypes.MFG_SELECTED:
      return { ...state, mfgSelected: action.mfgSelected };
    case actionTypes.GET_HANDLING_CODE: {
      return { ...state, handlingCodeValues: action.payload };
    }
    case actionTypes.DISPLAY_INVOICE_OBJ: {
      return { ...state, displayInvoiceObj: action.displayInvoiceObj };
    }
    case actionTypes.GET_INVOICE_QUARTER: {
      return { ...state, invoiceQuarter: action.payload };
    }
    case actionTypes.GET_INVOICE_CODE: {
      return { ...state, invoiceStatusCodeValues: action.payload };
    }
    case actionTypes.GET_BALANCE_CODE: {
      return { ...state, balanceStatusCodeValues: action.payload };
    }
    case actionTypes.GET_INVOICE_OTHER_QUARTER: {
      return { ...state, invoiceOtherQuarter: action.payload };
    }
    case actionTypes.GET_INVOICE_QUARTER_TOTALS: {
      return { ...state, invoiceQuarterTotals: action.payload };
    }

    case 'SET_SAVE_REQUEST': {
      return { ...state, saveRequestData: action.payload };
    }
    case actionTypes.SAVED_INVOICE_DETAILS: {
      return { ...state, savedInvoiceDetails: action.payload };
    }
    case 'SEARCH_INVOICE_REQUEST': {
      return { ...state, searchInvoiceRequest: action.payload };
    }
    case actionTypes.SET_SELECTED_CLIENT: {
      return { ...state, selectedClient: action.payload };
    }
    case actionTypes.SET_INVOICE_NUMBER: {
      return { ...state, invoiceNumber: action.payload };
    }
    case 'SET_CHECK_LOG_OPEN': {
      return { ...state, isCheckLogOpen: action.payload };
    }
    case 'SET_INVOICE_OTHER_QTR_INDEX': {
      return { ...state, invoiceOtherQtrIndex: action.payload };
    }
    case actionTypes.SET_INVOICE_OTHER_HIDE_ZERO_BALANCE: {
      return { ...state, invoiceOther_hideZeroBalance: action.payload };
    }
    case actionTypes.SET_INVOICE_OTHER_SELECTED_QTR: {
      return { ...state, invoiceOther_selectedQtr: action.payload };
    }
    case 'TAB_DETAILS': {
      return { ...state, tabDetails: action.payload };
    }
    case actionTypes.GET_DRUG_ACTIVITY: {
      return {
        ...state,
        drugActivity: {
          ...action.payload,
          data:
            action.payload?.data?.length > 0
              ? action.payload.data?.map((item) => {
                  item.drugActivityDt = item.drugActivityDt
                    ? moment(item.drugActivityDt).format('MM/DD/yyyy')
                    : null;
                  return item;
                })
              : [],
        },
      };
    }

    case actionTypes.GET_CHECK_LOG_BY_INVOICE_NUM: {
      return { ...state, checkLogDetails: action.payload };
    }
    case actionTypes.SET_DEFAULT_QTR: {
      return { ...state, defaultQtr: action.defaultQtr };
    }
    case actionTypes.SET_ERROR_MESSAGES: {
      return { ...state, errorMessages: action.payload };
    }

    case actionTypes.SET_NO_RECORD_FOUND: {
      return { ...state, noRecordFound: !!action.payload };
    }

    case actionTypes.INVOICE_QTR: {
      return { ...state, invoiceQtr: action.payload };
    }

    case actionTypes.RESET_DISPLAY_INVOICE_STORE: {
      return { ...initilaState };
    }

    default:
      return state;
  }
};

export default reducer;
